import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslocoModule } from '@jsverse/transloco';
import { QaiIconComponent } from '@qai/ui';
@Component({
  imports: [QaiIconComponent, TranslocoModule],
  selector: 'app-previous-results-button',
  standalone: true,
  styleUrls: ['./previous-results-button.css'],
  templateUrl: './previous-results-button.html',
})
export class PreviousResultsButtonComponent {
  @Input() count? = 0;

  @Output() readonly clicked = new EventEmitter();

  protected handleClick() {
    this.clicked.emit();
  }
}
